// import React, { useState, useEffect } from "react";
// const divStyle = {
//   // background image commented out for now
//   // backgroundImage: 'url("https://media.istockphoto.com/id/1394894776/photo/mechanical-project-blueprint.jpg?s=612x612&w=0&k=20&c=qjKrT1Va2dVhRPscwHAy-ua_tnpq09LJkhhiMu78XAk=")',
//   backgroundPosition: "center",
//   transform: "0.7s",
//   animation: "sliderZoomEffect 12s linear infinite",
// };
// const Slider = () => {
//   const [activeIndex, setActiveIndex] = useState(0);

//   const slides = [
//     {
//       image: "img/slide2.jpeg",
//       title: "CAD Desk Services",
//       content: " Where imagination meets precision",
//     },
//     {
//       image: "img/slide1.jpeg",
//       title: "CAD Desk Services",
//       content: "Transforming ideas into reality",
//     },
//     {
//       image: "img/slide3.jpeg",
//       title: "CAD Desk Services",
//       content: "A step towards refining engineering skills",
//     },
//     {
//       image: "img/slide5.jpeg",
//       title: "CAD Desk Services",
//       content: "Designing the future with CAD",
//     },
//     {
//       image: "img/slide4.jpeg",
//       title: "CAD Desk Services",
//       content: "Empowering creativity with CAD",
//     },
//     // Add more slides as needed
//   ];

//   const nextSlide = () => {
//     setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
//   };

//   useEffect(() => {
//     const intervalId = setInterval(nextSlide, 5000); // Change 5000 to the desired interval in milliseconds (e.g., 5000 for 5 seconds)

//     return () => clearInterval(intervalId); // Clear the interval when the component is unmounted or updated
//   }, []);

//   return (
//     <div className="container-fluid carousel px-0 mb-5 pb-5">
//       <div id="carouselId" className="carousel slide" data-bs-ride="carousel">
//         {/* ... Other carousel elements ... */}
//         <div className="carousel-inner" role="listbox">
//           {slides.map((slide, index) => (
//             <div
//               key={index}
//               className={`carousel-item ${
//                 index === activeIndex ? "active" : ""
//               }`}
//             >
//               <div className="zoom_container">
//                 <div style={divStyle}>
//                   <img
//                     style={{ height: 600, width: 1500 }}
//                     src={slide.image}
//                     alt={`Slide ${index + 1}`}
//                   />
//                   <h1 className="bg_heading"></h1>
//                 </div>
//               </div>
//               <div className="carousel-caption">
//                 <div className="container carousel-content">
//                   <h4
//                     className="text-white mb-4 animated  slideInDown"
//                     style={{ textAlign: "center" }}
//                   >
//                     {slide.title}
//                   </h4>
//                   <h1
//                     className="text-white display-1 mb-4 animated slideInDown"
//                     style={{ textAlign: "center" }}
//                   >
//                     {slide.content}
//                   </h1>
//                   <a href="" className="me-2">
//                     {/* <button type="button" className="px-5 py-3 btn btn-primary border-2 rounded-pill animated slideInDown">
//                       Read More
//                     </button> */}
//                   </a>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//         <button
//           className="carousel-control-prev btn btn-primary border border-2 border-start-0 border-primary"
//           type="button"
//           data-bs-target="#carouselId"
//           data-bs-slide="prev"
//         >
//           <span
//             className="carousel-control-prev-icon"
//             aria-hidden="true"
//           ></span>
//           <span className="visually-hidden">Previous</span>
//         </button>
//         <button
//           className="carousel-control-next btn btn-primary border border-2 border-end-0 border-primary"
//           type="button"
//           data-bs-target="#carouselId"
//           data-bs-slide="next"
//         >
//           <span
//             className="carousel-control-next-icon"
//             aria-hidden="true"
//           ></span>
//           <span className="visually-hidden">Next</span>
//         </button>
//         {/* ... Other carousel elements ... */}
//       </div>
//     </div>
//   );
// };

// export default Slider;


import React, { useState, useEffect } from "react";

const Slider = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animationClass, setAnimationClass] = useState("");

  const slides = [
    {
      image: "/img/slide2.webp",
      title: "CAD Desk Services",
      content: "Where imagination meets precision",
    },
    {
      image: "/img/slide1.webp",
      title: "CAD Desk Services",
      content: "Transforming ideas into reality",
    },
    {
      image: "/img/slide3.webp",
      title: "CAD Desk Services",
      content: "A step towards refining engineering skills",
    },
    {
      image: "/img/slide5.webp",
      title: "CAD Desk Services",
      content: "Designing the future with CAD",
    },
    {
      image: "/img/slide4.webp",
      title: "CAD Desk Services",
      content: "Empowering creativity with CAD",
    },
  ];

  // Trigger animation when slide changes
  useEffect(() => {
    setAnimationClass("animate-out");
    const timer = setTimeout(() => {
      setAnimationClass("animate-in");
    }, 50);
    
    return () => clearTimeout(timer);
  }, [activeIndex]);

  // Auto Slide
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  // Next Slide
  const nextSlide = () => {
    setActiveIndex((prev) => (prev + 1) % slides.length);
  };

  // Prev Slide
  const prevSlide = () => {
    setActiveIndex((prev) =>
      prev === 0 ? slides.length - 1 : prev - 1
    );
  };

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === "ArrowLeft") {
        prevSlide();
      } else if (e.key === "ArrowRight") {
        nextSlide();
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, []);

  return (
    <div style={styles.container}>
      {slides.map((slide, index) => (
        <div
          key={index}
          style={{
            ...styles.slide,
            opacity: index === activeIndex ? 1 : 0,
            visibility: index === activeIndex ? "visible" : "hidden",
            transition: "opacity 0.8s ease-in-out, visibility 0.8s ease-in-out",
          }}
        >
          <img 
            src={slide.image} 
            alt={slide.title}
            style={styles.image}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "https://via.placeholder.com/1500x600?text=Image+Not+Found";
            }}
          />
          <div style={styles.overlay}>
            <div className={`text-container ${animationClass}`}>
              <h4 style={styles.title}>{slide.title}</h4>
              <h1 style={styles.content}>{slide.content}</h1>
            </div>
          </div>
        </div>
      ))}

      {/* Navigation Buttons */}
      <button 
        style={styles.prevBtn} 
        onClick={prevSlide}
        aria-label="Previous slide"
        className="nav-btn"
      >
        ❮
      </button>
      <button 
        style={styles.nextBtn} 
        onClick={nextSlide}
        aria-label="Next slide"
        className="nav-btn"
      >
        ❯
      </button>

      {/* Dots Navigation */}
      <div style={styles.dotsContainer}>
        {slides.map((_, index) => (
          <button
            key={index}
            style={{
              ...styles.dot,
              backgroundColor: index === activeIndex ? "#fff" : "rgba(255,255,255,0.5)",
              transform: index === activeIndex ? "scale(1.2)" : "scale(1)",
            }}
            onClick={() => setActiveIndex(index)}
            aria-label={`Go to slide ${index + 1}`}
            className="dot-btn"
          />
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    position: "relative",
    width: "100%",
    height: "600px",
    overflow: "hidden",
    backgroundColor: "#000",
  },
  slide: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    animation: "zoomEffect 12s ease-in-out infinite",
  },
  overlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "#fff",
    textAlign: "center",
    width: "80%",
    maxWidth: "800px",
    textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
    zIndex: 2,
  },
  title: {
    fontSize: "24px",
    marginBottom: "15px",
    fontWeight: "500",
    letterSpacing: "3px",
    textTransform: "uppercase",
    color:"#fff"
  },
  content: {
    fontSize: "52px",
    fontWeight: "bold",
    margin: 0,
    lineHeight: "1.2",
    color:"#fff"
  },
  prevBtn: {
    position: "absolute",
    top: "50%",
    left: "20px",
    transform: "translateY(-50%)",
    fontSize: "30px",
    background: "rgba(0,0,0,0.5)",
    color: "#fff",
    border: "none",
    padding: "10px 15px",
    cursor: "pointer",
    borderRadius: "50%",
    transition: "all 0.3s ease",
    zIndex: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  nextBtn: {
    position: "absolute",
    top: "50%",
    right: "20px",
    transform: "translateY(-50%)",
    fontSize: "30px",
    background: "rgba(0,0,0,0.5)",
    color: "#fff",
    border: "none",
    padding: "10px 15px",
    cursor: "pointer",
    borderRadius: "50%",
    transition: "all 0.3s ease",
    zIndex: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dotsContainer: {
    position: "absolute",
    bottom: "30px",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    gap: "12px",
    zIndex: 3,
  },
  dot: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    border: "none",
    cursor: "pointer",
    transition: "all 0.3s ease",
    padding: 0,
  },
};

// Add all CSS animations
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  /* Zoom Animation for Background Image */
  @keyframes zoomEffect {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  /* Text Animation Classes */
  .text-container {
    animation-duration: 0.8s;
    animation-fill-mode: both;
  }

  .animate-in {
    animation-name: slideInUp;
  }

  .animate-out {
    animation-name: slideOutDown;
  }

  /* Slide In Animation */
  @keyframes slideInUp {
    from {
      opacity: 0;
      transform: translateY(50px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Slide Out Animation */
  @keyframes slideOutDown {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(-50px);
    }
  }

  /* Button Hover Effects */
  .nav-btn:hover {
    background: rgba(0,0,0,0.8) !important;
    transform: translateY(-50%) scale(1.1) !important;
    box-shadow: 0 0 15px rgba(255,255,255,0.3);
  }
  
  .nav-btn:active {
    transform: translateY(-50%) scale(0.95) !important;
  }
  
  .dot-btn:hover {
    transform: scale(1.3) !important;
    background: #fff !important;
  }

  /* Additional Text Animations for different elements */
  .text-container h4 {
    animation: fadeInLeft 0.6s ease-out;
  }
  
  .text-container h1 {
    animation: fadeInRight 0.6s ease-out 0.2s both;
  }

  @keyframes fadeInLeft {
    from {
      opacity: 0;
      transform: translateX(-30px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes fadeInRight {
    from {
      opacity: 0;
      transform: translateX(30px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  /* Pulse Animation for Dots */
  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(255,255,255,0.7);
    }
    70% {
      box-shadow: 0 0 0 10px rgba(255,255,255,0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(255,255,255,0);
    }
  }

  /* Active Dot Pulse Effect */
  .dot-btn[style*="backgroundColor: #fff"] {
    animation: pulse 2s infinite;
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .text-container h4 {
      font-size: 18px !important;
      letter-spacing: 2px !important;
    }
    .text-container h1 {
      font-size: 28px !important;
    }
    .nav-btn {
      padding: 8px 12px !important;
      font-size: 24px !important;
    }
    .dot-btn {
      width: 8px !important;
      height: 8px !important;
    }
  }

  @media (max-width: 480px) {
    .text-container h4 {
      font-size: 14px !important;
      margin-bottom: 10px !important;
    }
    .text-container h1 {
      font-size: 20px !important;
    }
    .nav-btn {
      padding: 6px 10px !important;
      font-size: 20px !important;
    }
    .dotsContainer {
      gap: 8px !important;
      bottom: 20px !important;
    }
  }

  /* Optional: Add a gradient overlay for better text readability */
  .overlay::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.5) 100%);
    z-index: -1;
    border-radius: 10px;
  }
`;
document.head.appendChild(styleSheet);

export default Slider;
